import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: "#2cb9ef",
        secondary: "#ff8f32",
        buttonHover: "#fecc7f",
        standard: "#666",
        error: "#FF5252",
        success: "#47B38F",
        warning: "#ED6B07",
        inverted: "#FFF",
      },
    },
    options: {
      customProperties: true
    },
  },
})
